import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

const PATH = "/fi/ski-resorts";

export const Route = createFileRoute("/fi/ski-resorts/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("ski-resorts")),
  head: ({ loaderData }) => {
    const hub = (loaderData as any)?.hub;
    const places = ((loaderData as any)?.places ?? []) as { name: string; slug: string }[];
    const url = `https://whatfinland.com${PATH}`;
    const title = "Suomen hiihtokeskukset — hissit, rinteet ja kausi | what Finland";
    const desc = hub?.description_fi || "Suomen hiihtokeskukset: hissit, rinteet, korkeusero, kauden pituus ja kulkuyhteydet.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(PATH)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Ski resorts in Finland",
            url,
            numberOfItems: places.length,
            itemListElement: places.map((p, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: p.name,
              url: `${url}/${p.slug}`,
            })),
          }),
        },
      ],
    };
  },
  component: () => <HubIndexPage slug="ski-resorts" locale="fi" />,
});
